export const FETCH_BRANDS_REQUEST = 'FETCH_BRANDS_REQUEST';
export const FETCH_BRANDS_SUCCESS = 'FETCH_BRANDS_SUCCESS';
export const SAVE_BRAND_REQUEST = 'SAVE_BRAND_REQUEST';
export const SAVE_BRAND_SUCCESS = 'SAVE_BRAND_SUCCESS';
export const DELETE_BRAND_REQUEST = 'DELETE_BRAND_REQUEST';
export const DELETE_BRAND_SUCCESS = 'DELETE_BRAND_SUCCESS';

export const TERRITORIES = [
  {
    labelKey: 'brand:form.territories.us',
    value: 'US',
  },
  {
    labelKey: 'brand:form.territories.ca',
    value: 'CA',
  },
  {
    labelKey: 'brand:form.territories.gb',
    value: 'GB',
  },
];

export const OFFER_PAYOUT_OPTIONS = [
  {
    value: -1,
    labelKey: 'brand:form.rapid_transfer_options.default',
    key: 'default',
  },
  {
    value: 0,
    labelKey: 'brand:form.rapid_transfer_options.days_and_transactions',
    key: '0',
    days: 0,
    transactions: 0,
  },
  {
    value: 1,
    labelKey: 'brand:form.rapid_transfer_options.days_and_transactions',
    key: '30',
    days: 30,
    transactions: 10,
  },
  {
    value: 2,
    labelKey: 'brand:form.rapid_transfer_options.days_and_transactions',
    key: '60',
    days: 60,
    transactions: 20,
  },
  {
    value: 3,
    labelKey: 'brand:form.rapid_transfer_options.days_and_transactions',
    key: '90',
    days: 90,
    transactions: 30,
  },
];
